<template>
  <div class="navbar">
    <searchHome />
    <!-- <div class="right-menu">
      <span class="breadcrumb-container" style="margin-right: 30px;">
        <span class="el-breadcrumb__inner" style="font-size: 13px;">您好！{{ name }}</span>
      </span>
      <lang-select class="right-menu-item hover-effect" />

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img :src="logo" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
// import LangSelect from '@/components/LangSelect'
import SearchHome from '@/components/SearchHome'

import logoPng from '@/assets/logo_images/logo.png'

export default {
  components: {
    // Breadcrumb,
    // Hamburger,
    // LangSelect,
    SearchHome
  },
  data() {
    return {
      logo: logoPng
    }
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "name"])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      window.location.href = 'https://itp-open.leapmotor.com/#/usrLogin';
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: auto;
  overflow: hidden;
  position: relative;
  background: #fff;
  border-bottom: 1px solid #eaeaea;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 36px;
          /*height: 40px;*/
          border-radius: 10px;
          padding-top: 5px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
